import { FeedbackInitData, launchFeedback } from '@ms/inapp-feedback-loader';
import React, { useEffect } from 'react';
import useInAppFeedbackHelper from './useInAppFeedbackHelper';
import { getActiveAccount } from '@/services/token/tokenService';
import { getFeedbackConfig } from '@config/feedbackConfig';

interface FeedbackProps {
  setIsFeedbackModalOpen: (isOpen: boolean) => void;
}

export const Feedback: React.FC<FeedbackProps> = ({ setIsFeedbackModalOpen }) => {
  const onDismiss = () => {
    setIsFeedbackModalOpen(false);
  };
  const account = getActiveAccount();

  const { defaultFeedbackOptions } = useInAppFeedbackHelper(onDismiss);

  useEffect(() => {
    void (async () => {
      try {
        const hostName = getFeedbackConfig().hostName;
        const language: string = 'en';
        const inAppFeedbackRef = document.getElementById('inAppFeedbackRef-id');
        if (inAppFeedbackRef && hostName && language) {
          const feedbackInfo: FeedbackInitData = {
            hostName: hostName,
            locale: language,
            inAppFeedbackRef: inAppFeedbackRef,
          };
          if (defaultFeedbackOptions.feedbackConfig) {
            defaultFeedbackOptions.feedbackConfig.email = account?.username || '';
          }
          await launchFeedback(feedbackInfo, defaultFeedbackOptions);
        }
      } catch (e) {
        console.error('Error in loading feedback package. Error:', e);
      }
    })();
  }, [account?.username, defaultFeedbackOptions]);

  return <div id="inAppFeedbackRef-id" />;
};
